import i18next from 'i18next';
import { locales } from 'configs/i18n';

/* ------------------------------------- English ------------------------------------- */

i18next.addResources(locales.EN, 'US_VIEW', {
  TITLE: 'Us',
});

/* ------------------------------------- Spanish ------------------------------------- */

i18next.addResources(locales.ES, 'US_VIEW', {
  TITLE: 'Nosotros',
});
